<template>
  <f7-page>
    <f7-navbar
      sliding
      class="no-shadow"
      :style="appTheme"
    >
      <f7-nav-left name="frmResumenVolcadosPorFamilia-nav-lefth">
        <f7-link @click="NavigateBack()">
          <img
            alt="iconBack"
            src="@/static/icons/back.svg"
          >
        </f7-link>
      </f7-nav-left>
      <f7-nav-title>
        {{ $t('production.dump.summaryByFamily.title') }}
      </f7-nav-title>
    </f7-navbar>
    <PCInformacionLineaPunto class="navbar-color" />
    <div class="div-001">
      <div
        v-if="seleccionFamilia != null"
        class="div-registrosMovimientos"
      >
        <div
          v-for="volcado in volcadosFamiliaSeleccionada"
          :key="volcado.Id"
          class="div-registroMovimiento"
          @click="VerDetalleVolcado(volcado.Id)"
        >
          <f7-row>
            <f7-col
              width="80"
              class="div-horaRegistroMovimientoYPartida"
            >
              <div class="div-horaRegistroMovimiento">
                {{ ProcesarHora(volcado.FechaInicio) }}
              </div>
              <div class="div-numeroPartida">
                <span class="span-numeroPartida">
                  {{ `${$t('common.batch').toUpperCase()} ${volcado.SeriePartida}/${volcado.Numero}` }}
                </span>
                <br>
                <span
                  v-if="volcado.DatosOrigenUnidadLogistica != null
                    && volcado.DatosOrigenUnidadLogistica.length > 0"
                  class="span-texto-gris-1 span-partidas-origen"
                >
                  {{
                    $t('common.originBatchesAreValue', {
                      value: FormatearCadena(ObtenerCadenaNumerosPartidas(volcado.DatosOrigenUnidadLogistica), 20),
                    })
                  }}
                </span>
              </div>
            </f7-col>
            <f7-col
              width="20"
              class="col-ttlVolcadoORecuperado"
            >
              <span v-if="volcado.CantidadEnvases > 0">
                {{ $t('production.common.dumped') }}
              </span>
              <span v-if="volcado.CantidadEnvases < 0">
                {{ $t('production.common.retrieved') }}
              </span>
            </f7-col>
          </f7-row>
          <f7-row class="row-nombreProductoYCantidadEnvases">
            <f7-col
              width="80"
              class="col-productoRegistroMovimiento"
            >
              {{ FormatearCadena(volcado.FamiliaArticulo.Nombre, 23) }}
            </f7-col>
            <f7-col
              width="20"
              class="col-cantidadEnvasesVolcado"
            >
              <span
                v-if="volcado.CantidadEnvases > 0"
                class="span-ttl-unidades-volcadas"
              >{{ volcado.CantidadEnvases }} </span>
              <span
                v-if="volcado.CantidadEnvases < 0"
                class="span-ttl-unidades-recuperadas"
              >{{ volcado.CantidadEnvases }} </span>
            </f7-col>
          </f7-row>
        </div>
      </div>
      <UCPreload :show="volcadosFamiliaSeleccionada == null" />
    </div>
  </f7-page>
</template>

<script>
import { mapState, mapWritableState } from 'pinia';
import { useTraceabilityStore } from '@/js/stores/traceability';

import { Log, LogError } from '@/js/common/HIDebuggingSupport';
import eventBus from '@/js/event-bus';
import PCInformacionLineaPunto from '@/components/production/traceability/PCInformacionLineaPunto.vue';
import ConexionTA from '@/js/services/traceability/APITraceability';
import { HiDateTimeSupport, HiStringSupport } from '@/js/common/HIConversionSupport';
import UCPreload from '@/components/common/UCPreload.vue';
import { HiDialog, HiNotification } from '@/js/common/HINotificationSupport';
import { f7 } from 'framework7-vue';

export default {
  name: 'FrmSummaryOfDumpsByFamily',
  components: {
    PCInformacionLineaPunto,
    UCPreload,
  },

  props: [

  ],
  data() {
    return {
      puntoDeVolcadoSeleccionadoLocal: null, // Obtiene el punto de volcado seleccionado.
      seleccionFamilia: null, // Obtiene el elemento seleccionado de Familia.
      volcadosFamiliaSeleccionada: null, // Mantiene los volcados de la familia seleccionada.
    };
  },
  computed: {
    ...mapState(useTraceabilityStore, [
      'familiaArticuloSeleccionada',
      'puntoDeVolcadoSeleccionado',
    ]),

    ...mapWritableState(useTraceabilityStore, [
      'partidaSeleccionada',
      'volcadoSeleccionado',
    ]),

    appTheme() {
      return {
        '--f7-navbar-text-color': '#fff',
      };
    },
  },

  created() {
    this.ActivarListener();
    this.ObtenerVolcadosDeFamilia();
  },
  beforeUnmount() {
    this.DesactivarListener();
  },
  methods: {
    NavigateBack() {
      f7.views.main.router.back();
    },

    ActivarListener() {
      Log(this, this.ActivarListener.name);
      eventBus.on('frmRecuperarMercanciaVolcadaVistaPartida_movimientoRealizado', () => {
        this.ObtenerVolcadosDeFamilia();
      });
    },
    DesactivarListener() {
      Log(this, this.DesactivarListener.name);
      eventBus.off('frmRecuperarMercanciaVolcadaVistaPartida_movimientoRealizado');
    },

    ObtenerVolcadosDeFamilia() {
      Log(this, this.ObtenerVolcadosDeFamilia.name);
      this.seleccionFamilia = this.familiaArticuloSeleccionada;
      this.puntoDeVolcadoSeleccionadoLocal = this.puntoDeVolcadoSeleccionado;
      const self = this;
      ConexionTA.callObtenerVolcadosDeUnaFamilia(
        this.puntoDeVolcadoSeleccionadoLocal.Id,
        this.seleccionFamilia.Id,
      ).then((result) => {
        if (result.Valor) {
          self.volcadosFamiliaSeleccionada = JSON.parse(result.Mensaje);
        } else {
          HiNotification.Alert(result.Mensaje, this.$t('common.error'));
        }
      })
        .catch((error) => {
          LogError(error);
          HiDialog.Preloader(false);
          HiNotification.Alert(this.$t('common.checkYourConnection'), this.$t('common.error'));
        });
    },

    VerDetalleVolcado(idVolcado) {
      Log(this, this.VerDetalleVolcado.name);
      [this.seleccionVolcado] = this.volcadosFamiliaSeleccionada.filter((v) => v.Id === idVolcado);
      this.volcadoSeleccionado = this.seleccionVolcado;
      this.partidaSeleccionada = { Id: this.seleccionVolcado.Partida.Id };
      f7.views.main.router.navigate('/production/traceability/dumpAndRecoverMerchandise/retrieve/FrmRetrieveOverturnedMerchandiseSplitView');
    },

    ProcesarHora(fechaYHora) {
      Log(this, this.ProcesarHora.name);
      return HiDateTimeSupport.FormatDateTime(fechaYHora, 'HHMM');
    },

    FormatearCadena(cadena, longitudMaxima) {
      Log(this, this.FormatearCadena.name);
      return HiStringSupport.TextMaximumLength(cadena, longitudMaxima);
    },

    ObtenerCadenaNumerosPartidas(lstPartidas) {
      Log(this, this.ObtenerCadenaNumerosPartidas.name);
      let cadenaPartidas = '';
      try {
        lstPartidas.forEach((p) => {
          const seriePartida = p.Partida.Serie != null ? p.Partida.Serie : '';
          cadenaPartidas += `${seriePartida}/${p.Partida.Numero}, `;
        });
        cadenaPartidas = cadenaPartidas.slice(0, -2); // Quitamos el último carácter.
      } catch (error) {
        LogError('No se puedo obtener la cadena', error);
      }
      return cadenaPartidas;
    },
  },
};
</script>

<style scoped>
.div-preloaderCargaVolcadosFamiliaSeleccionada {
  text-align: -webkit-center;
  padding: 5%;
}

.div-registrosMovimientos {
  margin-top: 70px;
}

.div-registroMovimiento {
  margin-left: 28px;
  padding-right: 28px;
  margin-top: 14px;
  margin-bottom: 14px;
  border-bottom: 1px solid var(--his-disabled);
}

.div-horaRegistroMovimiento {
  max-height: 20px;
  border: 1px solid #009ba6;
  background: rgb(0 155 166 / 10%);
  border-radius: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #009ba6;
  font-size: 14px;
  font-weight: 400;
  line-height: 14px;
  max-width: 48px;
  min-height: 17px;
  min-width: 48px;
}

.span-numeroPartida {
  color: var(--his-darkgray);
  font-size: 14px;
  font-weight: 500;
  line-height: 14px;
}

.span-partidas-origen {
  text-transform: uppercase;
}

.col-cantidadEnvasesVolcado {
  font-size: 26px;
  font-weight: 900;
  line-height: 29px;
  color: #66ba33;
  display: flex;
  justify-content: center;
}

.col-cantidadEnvasesVolcado .span-ttl-unidades-volcadas {
  color: #66ba33;
}

.col-cantidadEnvasesVolcado .span-ttl-unidades-recuperadas {
  color: var(--his-tomate);
}

.col-productoRegistroMovimiento {
  font-size: 16px;
  font-weight: 500;
  line-height: 17px;
  color: #009ba6;
  padding-top: 7px;
}

.col-ttlVolcadoORecuperado {
  font-size: 13px;
  font-weight: 400;
  line-height: 14px;
  color: var(--his-silver);
  text-align: right;
  display: flex;
  justify-content: center;
}

.row-nombreProductoYCantidadEnvases {
  padding-bottom: 10px;
}

.div-horaRegistroMovimientoYPartida {
  display: flex;
}

.div-numeroPartida {
  margin-left: 20px;
}

.navbar-color {
  background-color: var(--his-darkgray) !important;
}
</style>
